module.exports = __webpack_public_path__ + "media/images/hero/hero-bg5-b628d8dc5b680b98b185fe0e70c59356.png";